import logo from '../../assets/huapu/huapu-logo.jpg';
import lowGILogo from '../../assets/huapu/low-gi-logo.png';
import qrCode from '../../assets/huapu/website-qr.png';

export const HUAPU = Object.freeze({
  name: '华谱（西安）生物科技有限公司',
  english: 'HUAPU BIOTECHNOLOGY',
  url: 'https://www.huapubio.net',
  method: 'WS/T 652-2019 《食物血糖生成指数测定方法》',
  platform: '华谱（西安）生物科技有限公司GI数字标签平台',
  logo, lowGILogo, qrCode,
});
// The supplied logo explicitly states <=55. Do not display it for missing,
// zero or higher GI values, even if a previous label left the toggle enabled.
export const showLowGI = gi => gi.reportPassed === true &&
  /^\d+(?:\.\d+)?$/.test(String(gi.gi).trim()) &&
  Number(gi.gi) > 0 && Number(gi.gi) <= 55;
